import { Header } from "./components/Header/Header";
import { Hero } from "./components/Hero/Hero";
import { About } from "./components/About/About";
import { AboutNumbers } from "./components/AboutNumbers/About-numbers";
import { Steps } from "./components/Steps/Steps";
import { Description } from "./components/Description/Description";
import { Offer } from "./components/Offer/Offer";
import { Projects } from "./components/Projects/Projects";
import { Questions } from "./components/Questions/Questions"; 
import { Contact } from "./components/Contact/Contact";
import { Footer } from "./components/Footer/Footer";
import { GoToTop } from "./components/GoToTop/GoToTop";
import Cookie from "./components/Cookie/Cookie";
import "aos/dist/aos.css";
import "./App.scss";
import Aos from "aos";
import { useEffect } from "react";

const App = () => {
  useEffect(() => {
    Aos.init({ duration: 1000, once: true });
  });

  return (
    <>
      <Header />
      <main>
        <Hero />
        <About />
        <AboutNumbers />
        <Steps />
        <Description />
        <Offer />
        <Projects />
        <Questions />
        <Contact />
        <GoToTop />
        <Cookie />
      </main>      
      <Footer />
    </>
  );
};

export default App;
